const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingCasesBreadcrumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.44498 1.5H12.5475C13.035 1.5 13.47 1.51502 13.86 1.56752C15.9375 1.80002 16.5 2.77501 16.5 5.44501V10.185C16.5 12.855 15.9375 13.83 13.86 14.0625C13.47 14.115 13.0425 14.13 12.5475 14.13H5.44498C4.95748 14.13 4.52248 14.115 4.13248 14.0625C2.05498 13.83 1.49249 12.855 1.49249 10.185V5.44501C1.49249 2.77501 2.05498 1.80002 4.13248 1.56752C4.52248 1.51502 4.95748 1.5 5.44498 1.5Z",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.185 6.23999H12.945",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05499 10.5825H5.06998H12.9525",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16.5H12.75",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39603 6.22501H5.40276",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87088 6.22501H7.87762",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingCasesBreadcrumb);
export default __webpack_public_path__ + "static/media/pending-cases-breadcrumb.c335d7a41ea2ddb09bd767775ce928a3.svg";
export { ForwardRef as ReactComponent };